import Entity from '../core/Entity';
import PagedResult from '../core/PagedResult';
import HttpClientV2 from '../utils/HttpClientV2';
import ApiResponseV2 from '../core/ApiResponseV2';
import { CrudServiceV2 } from './CrudServiceV2';
import GenericCrudServiceV2Interface from './GenericCrudServiceV2Interface';

/**
 *A generic CRUD (Create, Read, Update, Delete) service class that can handle operations on entities of type T.
 @template T - A type parameter that extends the Entity interface.
 */
export default class GenericCrudServiceV2<T extends Entity> implements GenericCrudServiceV2Interface<T> {
  constructor(protected basePath: string) {}

  get(id: string, context: { [key: string]: string | number } = {}): Promise<ApiResponseV2<T>> {
    return HttpClientV2.get(`${this.getBasePath(context)}/${id}`);
  }

  getById(id: number, context: { [key: string]: string | number } = {}): Promise<ApiResponseV2<T>> {
    return HttpClientV2.get(`${this.getBasePath(context)}/${id}`);
  }

  getByExternalId(externalId: string, context: { [key: string]: string | number } = {}): Promise<ApiResponseV2<T>> {
    return HttpClientV2.get(`${this.getBasePath(context)}/${externalId}`);
  }

  getAll(page: number, pageSize: number, context: { [key: string]: string | number } = {}): Promise<ApiResponseV2<PagedResult<T>>> {
    return HttpClientV2.get(`${this.getBasePath(context)}?page=${page}&pageSize=${pageSize}`);
  }

  create(instance: T, context: { [key: string]: string | number } = {}): Promise<ApiResponseV2<T>> {
    return HttpClientV2.post(this.getBasePath(context), instance);
  }

  update(instance: T, context: { [key: string]: string | number } = {}): Promise<ApiResponseV2<T>> {
    return HttpClientV2.put(`${this.getBasePath(context)}/${instance.externalId}`, instance);
  }

  delete(instance: T, context: { [key: string]: string | number } = {}): Promise<ApiResponseV2<T>> {
    return HttpClientV2.delete(`${this.getBasePath(context)}/${instance.externalId}`);
  }

  getBasePath(context: { [key: string]: string | number }): string {
    return this.basePath;
  }
}
